import { component } from 'picoapp'
import { getNewCookie, setNewCookie, deleteCookie } from '@/lib/ults.js'
import $ from 'jquery'

export default component((node) => {
    const inputs = node.querySelectorAll('[data-input]')
    const labels = node.querySelectorAll('[data-label]')
    const removes = node.querySelectorAll('[data-remove]')
    const checkboxes = node.querySelectorAll('[data-checkbox]')
    const propertyNames = node.querySelectorAll('[data-property]')
    let ids = []

    inputs.forEach((input) => {
        const id = input.getAttribute('data-id')
        ids.push(id)
    })

    function hasWrapping() {
        inputs.forEach((input, i) => {
            let cookieName = labels[i].getAttribute('data-product-title')
            if (getNewCookie(cookieName) != null) {
                input.checked = true
                checkboxes[i].classList.add('checked')
            } else {
                input.checked = false
                checkboxes[i].classList.remove('checked')
            }
        })
    }
    hasWrapping()

    labels.forEach((label, i) => {
        const productTitle = label.getAttribute('data-product-title')
        const productId = label.getAttribute('data-product-id')

        label.addEventListener('click', () => {
            if (inputs[i].checked) {
                inputs[i].checked = false
                checkboxes[i].classList.remove('checked')

                fetch('/cart.js')
                    .then((r) => r.json())
                    .then((cart) => {
                        const cartItems = cart.items

                        cartItems.forEach((item) => {
                            const key = item.key
                            const itemProperties = item.properties
                            const name = itemProperties.Produkt
                            const id = item.id

                            if (name == productTitle) {
                                $.post({
                                    url: '/cart/change.js',
                                    data: {
                                        quantity: 0,
                                        id: key,
                                    },
                                    dataType: 'JSON',
                                    success: function () {
                                        deleteCookie(productTitle)
                                        location.reload()
                                    },
                                })
                            }
                        })
                    })
            } else {
                inputs[i].checked = true
                checkboxes[i].classList.add('checked')
                setNewCookie(productTitle, productId, 1)

                $.ajax({
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: ids[i],
                        properties: {
                            Produkt: productTitle,
                        },
                    },
                    dataType: 'JSON',
                    success: function () {
                        location.reload()
                    },
                    error: function () {
                        console.log('error')
                    },
                })
            }
        })
    })

    if (propertyNames.length > 0) {
        removes.forEach((remove, i) => {
            let cookieName = propertyNames[i].getAttribute('data-property-name')

            remove.addEventListener('click', (e) => {
                if (getNewCookie(cookieName) != null) {
                    e.preventDefault()
                    deleteCookie(cookieName)
                    window.location = remove.getAttribute('href')
                }
            })
        })
    }
})
